import { GPIErrorCodes, PaymentErrors } from '../enums';
import { PaymentProviderId, PaymentProvidersById } from '../types';

export class PaymentProviderError extends Error {
	code: string;
	paymentProviderId: PaymentProviderId;
	category?: string;
	subcategory?: string;
	retryable?: boolean;
	opsIssue?: boolean;
	rawMessage?: string;
	private notifyUser?: boolean;

	constructor(
		code: string,
		message: string,
		paymentProviderId: PaymentProviderId = PaymentProvidersById.GPI,
		metadata: {
			category?: string;
			subcategory?: string;
			retryable?: boolean;
			notifyUser?: boolean;
			opsIssue?: boolean;
			rawMessage?: string;
		} = {},
	) {
		super(message);
		this.code = code;
		this.paymentProviderId = paymentProviderId;
		this.category = metadata.category;
		this.subcategory = metadata.subcategory;
		this.retryable = metadata.retryable;
		this.notifyUser = metadata.notifyUser;
		this.opsIssue = metadata.opsIssue;
		this.rawMessage = metadata.rawMessage;
	}

	get shouldNotifyUser() {
		if (this.notifyUser !== undefined) {
			return this.notifyUser;
		}

		return (
			this.code === GPIErrorCodes.INVALID_INPUT ||
			this.message === PaymentErrors.PAYMENT_DECLINED ||
			this.paymentProviderId === PaymentProvidersById.SlidePay
		);
	}
}
